import { OcrResult } from "@finway-group/shared/lib/models"
import moment from "moment"
import React from "react"
import i18n from "~Shared/locales/i18n"
import { formatAddress, getInvoiceTypeLabel, getReceiverCountryCode, getSenderCountryCode } from "../utils/helpers"
import { DataRow, DataSection, SectionHeader } from "./shared"

interface DetailsProps {
    data: OcrResult
}

export const EInvoiceDetails = ({ data }: DetailsProps) => {
    if (!data.eInvoiceData) {
        return null
    }

    const invoiceTypeCode = Number(data.eInvoiceData?.invoiceTypeCode)
    const invoiceTypeLabel = getInvoiceTypeLabel(invoiceTypeCode)
    const formattedDate = moment(data.invoiceDate).format("DD.MM.YYYY")
    const formattedPerformanceDate = data.eInvoiceData?.delivery?.date ? moment(data.eInvoiceData?.delivery?.date).format("DD.MM.YYYY") : undefined
    const billingPeriod =
        data.performancePeriod?.[0] && data.performancePeriod?.[1]
            ? `${moment(data.performancePeriod[0]).format("DD.MM.YYYY")} - ${moment(data.performancePeriod[1]).format("DD.MM.YYYY")}`
            : "n/a"

    return (
        <>
            <SectionHeader title={i18n.t("label:invoice_details")} />
            <DataSection>
                <DataRow label={i18n.t("label:currency")} value={data.currency} isAlternate />
                <DataRow label={i18n.t("label:billing_period")} value={billingPeriod} />
                <DataRow label={i18n.t("label:invoice_number")} value={data.invoiceNumber} isAlternate />
                <DataRow label={i18n.t("label:invoice_date")} value={formattedDate} />
                {formattedPerformanceDate && <DataRow label={i18n.t("label:performance_date")} value={formattedPerformanceDate} />}
                <DataRow label={i18n.t("label:invoice_type")} value={`${invoiceTypeCode} - ${invoiceTypeLabel}`} isAlternate />
            </DataSection>

            <SectionHeader title={i18n.t("label:seller_information")} />
            <DataSection>
                {data.eInvoiceData?.sender && (
                    <>
                        <DataRow label={i18n.t("label:company_name")} value={data.eInvoiceData.sender.senderName} isAlternate />
                        <DataRow label={i18n.t("label:number")} value={data.eInvoiceData.sender.senderId} />
                        <DataRow label={i18n.t("label:address")} value={formatAddress(data.eInvoiceData.sender.senderAddress, getSenderCountryCode(data))} isAlternate />
                        <DataRow label={i18n.t("label:tax_number")} value={data.eInvoiceData.sender.senderTaxId} />
                        <DataRow label={i18n.t("label:vat_id")} value={data.eInvoiceData.sender.senderVatNumber} isAlternate />
                    </>
                )}
            </DataSection>

            <SectionHeader title={i18n.t("label:buyer_service_recipient")} />
            <DataSection>
                {data.eInvoiceData?.receiver && (
                    <>
                        <DataRow label={i18n.t("label:number")} value={data.eInvoiceData.receiver.receiverId} isAlternate />
                        <DataRow label={i18n.t("label:company_name")} value={data.eInvoiceData.receiver.receiverName} />
                        <DataRow label={i18n.t("label:address")} value={formatAddress(data.eInvoiceData.receiver.receiverAddress, getReceiverCountryCode(data))} isAlternate />
                    </>
                )}
            </DataSection>
        </>
    )
}
